import { Component, OnDestroy, OnInit } from '@angular/core';

import { filter, Subscription } from 'rxjs';

import { DateQueryModel } from '../../../../Common/Forms/models/date-query.model';
import { FilterTypeModel } from '../../../../Common/Filter/models/abstract-filter-type.model';
import { SocialRouteModel } from '../../../SocialRouter/models/social-route.model';
import { SocialRoutingService } from '../../../Core/services/social-routing.service';
import { MentionSearchCriteriaModel } from '../../../../Monitor/Shared/models/mention-search-criteria.model';
import { SocialSearchService } from '../../../Core/services/social-search.service';
import { SocialSeriesService } from '../../services/social-series.service';
import { ThemeAnalyticsComponent } from '../ThemeAnalytics/theme-analytics.component';

@Component({
    selector: 'agpr-theme',
    templateUrl: './theme.component.html',
    styleUrls: ['./theme.component.scss'],
    standalone: false
})
export class ThemeComponent implements OnInit, OnDestroy {
    id: string = 'theme';

    public socialRouteModel: SocialRouteModel = null;

    private subscriptions: Subscription[] = [];
    private socialSearchCriteria: MentionSearchCriteriaModel;
    private activeFilters: FilterTypeModel[] = [];
    private searchDateRange: DateQueryModel;
    private agentIds: number[] = [];

    constructor(
        private socialRoutingService: SocialRoutingService,
        private socialSearchService: SocialSearchService,
        private socialSeriesService: SocialSeriesService
    ) { }

    ngOnInit(): void {
        this.subscriptions.push(
            this.socialRoutingService.getCurrentRoute$().subscribe(
                mode => {
                    // To prevent expression changed error
                    requestAnimationFrame(() => {
                        this.socialRouteModel = mode;
                    });
                }
            ),
            this.socialSearchService.getSearchCriteria().subscribe(searchCriteria => this.socialSearchCriteria = searchCriteria)
        );
    }

    onDeactivateComponent(component) {
        if (component.activeFilters) {
            this.activeFilters = component.activeFilters;
        }
        if (component.searchDateRange) {
            this.searchDateRange = component.searchDateRange;
        }
        if (component.agentIds) {
            this.agentIds = component.agentIds;
        }
    }

    onActivateComponent(component) {
        if (component instanceof ThemeAnalyticsComponent) {
            if (this.activeFilters.length > 0) {
                this.socialSeriesService.applyActiveFilters(this.activeFilters);
            }
            if (this.searchDateRange) {
                this.socialSeriesService.setDateQuery(this.searchDateRange);
            }
            if (this.agentIds.length > 0) {
                this.socialSeriesService.setAgents(this.agentIds);
            }
        } else {
            if (this.activeFilters.length > 0) {
                this.socialSearchService.applyActiveFilters(this.activeFilters);
            }
            if (this.searchDateRange) {
                this.socialSearchService.setDateQuery(this.searchDateRange);
            }
            if (this.agentIds.length > 0) {
                this.socialSearchService.setAgents(this.agentIds);
            }
        }
    }

    ngOnDestroy(): void {
        this.subscriptions.map(
            subscription => subscription.unsubscribe()
        );
        this.socialSearchService.setPageSize(25);
        this.socialSearchService.clearSearch();
        this.socialSearchService.clearFilters();
    }
}
